import Vue from 'vue'

import Cookies from 'js-cookie'

import 'normalize.css/normalize.css' // a modern alternative to CSS resets

import Element from 'element-ui'
import '@/styles/index.css' // element ui
// import './styles/element-variables.scss'
// import enLang from 'element-ui/lib/locale/lang/en'// 如果使用中文语言包请默认支持，无需额外引入，请删除该依赖

import '@/styles/index.scss' // global css

import App from './App'
import store from './store'
import router from './router'
import './utils/rem'
import './icons' // icon
import './permission' // permission control
import './utils/error-log' // error log
// import '@/assets/icon/iconfont.css'// 引入矢量图标库
import * as echarts from 'echarts';
import Table from '@/components/table/table.vue'
import Pagination from '@/components/pagination'
import './assets/iconfont/iconfont.css'
Vue.prototype.$echarts = echarts

import * as directives from './directive'
Object.keys(directives).forEach(k => Vue.directive(k, directives[k]))

import * as filters from './filters' // global filters

Vue.use(Element, {
  size: Cookies.get('size') || 'medium' // set element-ui default size
  // locale: enLang // 如果使用中文，无需设置，请删除
})
Vue.component('Table', Table)
Vue.component('Pagination', Pagination)
// register global utility filters
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})
